var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartsaNewLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 40,
    viewBox: "0 0 188 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.9786L9.29467 30.6535L11.1676 16.0845L0 27.9786Z",
    fill: "#0000DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29468 30.6535L23.0564 27.2521L11.1676 16.0845L9.29468 30.6535Z",
    fill: "url(#paint0_linear_33_614)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29467 30.6535L11.8888 39.1463L0 27.9787L9.29467 30.6535Z",
    fill: "#0000C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29468 30.6535L23.0564 27.2521L11.8888 39.1462L9.29468 30.6535Z",
    fill: "url(#paint1_linear_33_614)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4515 15.9338C20.3546 16.542 16.5872 16.472 12.0233 15.7724C7.45939 15.0727 3.8427 14.0232 3.95034 13.4205C4.05798 12.8177 7.8146 12.8823 12.3731 13.5819C16.9317 14.2816 20.5645 15.3311 20.4515 15.9338Z",
    fill: "#C6062B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2537 28.3339C15.7004 28.3339 19.3051 24.6617 19.3051 20.1318C19.3051 15.6018 15.7004 11.9296 11.2537 11.9296C6.80702 11.9296 3.20227 15.6018 3.20227 20.1318C3.20227 24.6617 6.80702 28.3339 11.2537 28.3339Z",
    fill: "url(#paint2_radial_33_614)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96649 13.3881L20.473 15.9015L14.5959 0.616699L3.96649 13.3881Z",
    fill: "#C90D1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19794 13.4096L20.2524 15.8531L14.5905 0.62207L4.19794 13.4096Z",
    fill: "#CB0F21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42395 13.4312L20.0317 15.81L14.5851 0.627441L4.42395 13.4312Z",
    fill: "#CD1122"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6554 13.4527L19.8057 15.7615L14.5798 0.632812L4.6554 13.4527Z",
    fill: "#CF1424"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88684 13.4742L19.585 15.7131L14.5744 0.643616L4.88684 13.4742Z",
    fill: "#D11625"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11829 13.4958L19.3644 15.6647L14.569 0.648987L5.11829 13.4958Z",
    fill: "#D31827"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34961 13.512L19.1436 15.6163L14.5635 0.654419L5.34961 13.512Z",
    fill: "#D51A29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58112 13.5335L18.923 15.5679L14.5583 0.65979L5.58112 13.5335Z",
    fill: "#D81C2A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80713 13.5549L18.7023 15.5194L14.5528 0.6651L5.80713 13.5549Z",
    fill: "#DA1F2C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03857 13.5764L18.4817 15.4709L14.5475 0.670471L6.03857 13.5764Z",
    fill: "#DC212E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26996 13.598L18.2556 15.4224L14.5421 0.681213L6.26996 13.598Z",
    fill: "#DE232F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5014 13.6142L18.035 15.3741L14.5367 0.686646L6.5014 13.6142Z",
    fill: "#E02531"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73285 13.6357L17.8143 15.3256L14.5313 0.692017L6.73285 13.6357Z",
    fill: "#E22732"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95886 13.6572L17.5936 15.2772L14.5259 0.697449L6.95886 13.6572Z",
    fill: "#E42934"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19037 13.6788L17.3731 15.2288L14.5206 0.70282L7.19037 13.6788Z",
    fill: "#E62C36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42169 13.7003L17.1523 15.1803L14.5151 0.708191L7.42169 13.7003Z",
    fill: "#E82E37"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65314 13.7165L16.9317 15.1319L14.5098 0.713623L7.65314 13.7165Z",
    fill: "#EA3039"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87921 13.738L16.7057 15.0835L14.5044 0.724426L7.87921 13.738Z",
    fill: "#EC323A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11066 13.7596L16.485 15.0351L14.4991 0.729797L8.11066 13.7596Z",
    fill: "#EE343C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34204 13.781L16.2643 14.9865L14.4936 0.735046L8.34204 13.781Z",
    fill: "#F0373E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57349 13.8025L16.0437 14.9381L14.4883 0.740479L8.57349 13.8025Z",
    fill: "#F3393F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80487 13.824L15.823 14.8897L14.4829 0.74585L8.80487 13.824Z",
    fill: "#F53B41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03638 13.8402L15.6024 14.8412L14.4776 0.751221L9.03638 13.8402Z",
    fill: "#F73D43"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26233 13.8618L15.3816 14.7928L14.4721 0.756653L9.26233 13.8618Z",
    fill: "#F93F44"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49384 13.8833L15.1557 14.7444L14.4668 0.767395L9.49384 13.8833Z",
    fill: "#FB4246"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72522 13.9048L14.935 14.6959L14.4614 0.772766L9.72522 13.9048Z",
    fill: "#FD4447"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95667 13.9263L14.7143 14.6475L14.456 0.778137L9.95667 13.9263Z",
    fill: "#FF4649"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M3.99878 13.3343L14.386 14.6475L14.5959 0.643616L3.99878 13.3343Z",
    fill: "url(#paint3_linear_33_614)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6515 16.8813C43.6529 17.4576 45.8499 18.286 47.2426 19.3665C48.6353 20.423 49.3316 21.9357 49.3316 23.9046C49.3316 26.0657 48.5032 27.8425 46.8464 29.2352C45.1896 30.6038 42.9686 31.2881 40.1833 31.2881C38.8386 31.2881 37.566 31.1201 36.3655 30.7839C35.1889 30.4237 34.2044 29.9795 33.4121 29.4513C32.6437 28.923 32.0794 28.5028 31.7193 28.1907C31.3591 27.8785 31.083 27.6024 30.8909 27.3623L32.6197 24.2648C34.7567 26.6419 37.3019 27.8305 40.2553 27.8305C42.0561 27.8305 43.4368 27.4943 44.3973 26.822C45.3817 26.1497 45.874 25.2253 45.874 24.0487C45.874 22.2238 44.0371 20.9873 40.3633 20.339C37.1698 19.7867 34.9248 18.9583 33.6282 17.8538C32.3556 16.7252 31.7193 15.2846 31.7193 13.5317C31.7193 11.4908 32.4876 9.80997 34.0244 8.48935C35.5611 7.16873 37.6981 6.50841 40.4354 6.50841C43.5809 6.50841 46.1861 7.46887 48.2511 9.38977L46.5943 12.5233C44.8415 10.8184 42.7645 9.96605 40.3633 9.96605C38.7066 9.96605 37.422 10.2662 36.5095 10.8665C35.6211 11.4668 35.1769 12.3072 35.1769 13.3877C35.1769 14.3001 35.5971 15.0204 36.4375 15.5487C37.2779 16.0529 38.6826 16.4971 40.6515 16.8813Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.748 31.5763L58.0404 16.6652L55.7353 31H52.2056L56.3116 6.22028L65.748 24.5169L75.1845 6.22028L79.2904 31H75.7608L73.4557 16.6652L65.748 31.5763Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M100.607 31L98.2658 25.8135H87.3886L85.0475 31H81.3018L92.8272 6.22028L104.353 31H100.607ZM88.9734 22.3559H96.681L92.8272 13.8559L88.9734 22.3559Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.531 31H120.497L114.482 22.644H110.701V31H107.243V6.79655H114.735C117.784 6.79655 120.077 7.49288 121.614 8.88554C123.175 10.2782 123.955 12.1631 123.955 14.5402C123.955 16.4371 123.451 18.0939 122.442 19.5106C121.458 20.9032 120.077 21.8397 118.3 22.3199L124.531 31ZM110.701 10.2542V19.1864H115.851C117.22 19.1864 118.336 18.8262 119.201 18.1059C120.065 17.3615 120.497 16.245 120.497 14.7563C120.497 13.2436 120.065 12.1151 119.201 11.3707C118.36 10.6264 117.268 10.2542 115.923 10.2542H110.701Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M126.245 6.79655H142.38V10.2542H136.041V31H132.584V10.2542H126.245V6.79655Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M155.034 16.8813C158.035 17.4576 160.232 18.286 161.625 19.3665C163.017 20.423 163.714 21.9357 163.714 23.9046C163.714 26.0657 162.885 27.8425 161.229 29.2352C159.572 30.6038 157.351 31.2881 154.565 31.2881C153.221 31.2881 151.948 31.1201 150.748 30.7839C149.571 30.4237 148.587 29.9795 147.794 29.4513C147.026 28.923 146.462 28.5028 146.101 28.1907C145.741 27.8785 145.465 27.6024 145.273 27.3623L147.002 24.2648C149.139 26.6419 151.684 27.8305 154.638 27.8305C156.438 27.8305 157.819 27.4943 158.779 26.822C159.764 26.1497 160.256 25.2253 160.256 24.0487C160.256 22.2238 158.419 20.9873 154.746 20.339C151.552 19.7867 149.307 18.9583 148.01 17.8538C146.738 16.7252 146.101 15.2846 146.101 13.5317C146.101 11.4908 146.87 9.80997 148.407 8.48935C149.943 7.16873 152.08 6.50841 154.818 6.50841C157.963 6.50841 160.568 7.46887 162.633 9.38977L160.977 12.5233C159.224 10.8184 157.147 9.96605 154.746 9.96605C153.089 9.96605 151.804 10.2662 150.892 10.8665C150.003 11.4668 149.559 12.3072 149.559 13.3877C149.559 14.3001 149.979 15.0204 150.82 15.5487C151.66 16.0529 153.065 16.4971 155.034 16.8813Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M184.178 31L181.837 25.8135H170.959L168.618 31H164.873L176.398 6.22028L187.923 31H184.178ZM172.544 22.3559H180.252L176.398 13.8559L172.544 22.3559Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_614",
    x1: 9.29468,
    y1: 23.3717,
    x2: 23.0564,
    y2: 23.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_614",
    x1: 9.29468,
    y1: 33.1992,
    x2: 23.0564,
    y2: 33.1992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_33_614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.22669 14.7763) scale(12.4404 12.6261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F67D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB623A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_614",
    x1: 4.0202,
    y1: 7.37388,
    x2: 14.7699,
    y2: 7.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF4649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4649"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsaNewLogoLight);
export default __webpack_public_path__ + "static/media/smartsa-new-logo-light.d87dca41a368425fbea2fc9364289977.svg";
export { ForwardRef as ReactComponent };